import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import Home from "./components/Home";
import NotFound from "./components/NotFound";
import Matchs from "./components/Matchs";
import Joueurs from "./components/Joueurs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import logo from "./assets/img/svg/logo.svg";
import Mentions from "./components/Mentions-Legales";
import { ScrollToAnchor } from "./utils/utils";

function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isCollapsed]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const closeCollapse = () => {
    setIsCollapsed(false);
  };

  return (
    <DataProvider>
      <Router>
        <ScrollToAnchor />
        <div className="App d-flex flex-column min-vh-100">
          <header className="App-header">
            <nav id="navbar" className="navbar navbar-expand-lg navbar-light">
              <Link className="navbar-brand" to="/" onClick={closeCollapse}>
                <img
                  src={logo}
                  alt="Logo"
                  width="250"
                  height="160"
                  className="navbar-logo"
                />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleCollapse}
                aria-controls="navbarSupportedContent"
                aria-expanded={isCollapsed}
                aria-label="Toggle navigation"
              >
                <span className="nv-icon"></span>
                <span className="nv-icon"></span>
                <span className="nv-icon"></span>
              </button>
              <div
                className={`navbar-collapse ${isCollapsed ? "show" : ""}`}
                id="navbarSupportedContent"
              >
                <button
                  className="close-button"
                  onClick={toggleCollapse}
                  aria-label="Close"
                ></button>
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  <li>
                    <Link className="navbar-brand-collapse" to="/" onClick={closeCollapse}>
                      <img
                        src={logo}
                        alt="Logo"
                        width="250"
                        height="160"
                        className="navbar-logo"
                      />
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="./#infos-pratiques"
                      onClick={closeCollapse}
                    >
                      Informations pratiques
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/joueurs"
                      onClick={closeCollapse}
                    >
                      Joueurs
                    </Link>
                  </li>


                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/matchs"
                      onClick={closeCollapse}
                    >
                      Matchs
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/contact" onClick={closeCollapse}>
                      Contact
                    </Link>
                  </li>

                </ul>
              </div>
            </nav>
          </header>
          <main className="flex-grow-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/matchs" element={<Matchs />} />
              <Route path="/joueurs" element={<Joueurs />} />
              <Route path="/mentions-legales" element={<Mentions />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
